<style lang="less" scoped>
  .match-slot {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-right: 1px solid rgba(255, 255, 255, .2);
    &:last-child {
      border-right: none;
    }
    &.currect {
      background: rgba(0, 0, 255, .3);
    }
    &.wrong {
      background: rgba(255, 0, 0, .5);
    }
    .answer,
    .input {
      height: 50%;
      display: flex;
      align-items: center;
    }
  }
</style>

<template lang="pug">
  .match-slot(:class='{ currect: matched, wrong: !matched }')
    .answer
      number-component(
        :number='answer'
        :width='width')
    .input
      number-component(
        v-if='input !== null'
        :number='input'
        :type='matched ? "green" : "red"'
        :width='width')
</template>

<script>
import NumberComponent from '@/components/number_panel';

export default {
  props: {
    answer: {
      type: Number,
    },
    input: {
      type: Number,
      default: null,
    },
    width: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      matched: false,
    };
  },
  created() {
    let matched = true;
    if (this.answer !== this.input) {
      matched = false;
    }
    this.matched = matched;
  },
  components: {
    NumberComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/match_number_slot.vue